var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecondaryHenPack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16.466 37.693)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.466 -37.693)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.75,47.5a45,45,0,1,0-45-45,45,45,0,0,0,45,45",
    transform: "translate(21.25 42.5)",
    fill: "#fcaa3c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.872 17.245)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.624,0H26.068c.976,0,1.222.25,1.222,1.237,0,1.817.072,3.636-.019,5.449-.1,2,.553,3.863.928,5.773A74.866,74.866,0,0,1,29.929,26.8a50.616,50.616,0,0,1-2.24,14.137c-.409,1.417-.686,2.872-1.057,4.3a14.137,14.137,0,0,1-.584,1.658.7.7,0,0,0,.18.862c.79.771,1.563,1.561,2.346,2.338.324.32.561.661.341,1.133-.231.491-.652.536-1.129.491q-8.138-.75-16.276-1.487c-2.145-.2-4.286-.462-6.436-.57a11.558,11.558,0,0,0-3.056.32c-2.308.515-4.593,1.133-6.889,1.7-.644.159-1.2-.178-1.148-.807.2-2.213-.623-4.227-1.15-6.294A76.544,76.544,0,0,1-9.335,33.433a41.549,41.549,0,0,1,.116-8.585A137.406,137.406,0,0,1-6.141,8.875a3.881,3.881,0,0,0,.1-.843c.006-2.264,0-4.525,0-6.787C-6.042.258-5.79,0-4.82,0H10.624m10.69,46.184h2.279c.953,0,.985.008,1.239-.94.436-1.631.781-3.287,1.247-4.911a48.094,48.094,0,0,0,2.132-14.362A58.516,58.516,0,0,0,26.68,13.8a40.062,40.062,0,0,1-1.1-11.262c.013-.26,0-.523,0-.8H-4.333v.6c0,1.94,0,3.882,0,5.824a4.1,4.1,0,0,1-.091.9A150.533,150.533,0,0,0-7.4,24.025a42.61,42.61,0,0,0-.33,8A58.449,58.449,0,0,0-6.048,42.01c.339,1.393.712,2.778,1.076,4.191h2.293v1.713H-4.432c.051.629.1,1.207.146,1.828.184-.032.339-.051.489-.087q2.15-.534,4.3-1.076a13.087,13.087,0,0,1,4.678-.652c.957.108,1.914.188,2.872.275q7.554.689,15.107,1.376c.856.076,1.709.144,2.626.222a11.694,11.694,0,0,1-1.241-1.478.744.744,0,0,0-.784-.434c-.811.023-1.622.006-2.444.006Z",
    transform: "translate(9.506)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(28.452 31.134)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5,0l1,1.29A15.392,15.392,0,0,0,.334,20.454C1.3,19.713,2.3,19.031,3.2,18.237A30.661,30.661,0,0,0,5.671,15.73a8.868,8.868,0,0,0,1.781-3.661,8.185,8.185,0,0,1,6.815-6.133c.483-.1.98-.121,1.472-.18-.023-.324-.061-.623-.061-.921A1.363,1.363,0,0,1,17.193,3.31a11.6,11.6,0,0,1,1.55.324,2.055,2.055,0,0,0,.692,0,3.437,3.437,0,0,0,.546-.208,2.154,2.154,0,0,1,3.117,1.6.627.627,0,0,0,.053.121,7.783,7.783,0,0,1,1.271.377A2.1,2.1,0,0,1,25.236,8.8a1.945,1.945,0,0,0-.352,1.688,6.389,6.389,0,0,1-.08,1.726,3.317,3.317,0,0,1,1.165,3.107c-.087.731-.483,1.012-1.216.883-1.275-.222-2.552-.44-3.852-.665-.4,2.382-2.215,3.287-4.127,4.07.324,2.916.646,5.811.976,8.765a15,15,0,0,0,4.542-1.921l.894,1.389A17.068,17.068,0,0,1,3.5,0M15.914,28.7a8.677,8.677,0,0,0,0-.881c-.3-2.778-.582-5.559-.928-8.331a5.531,5.531,0,0,1,2.956-5.614c.521-.212,1.184-.2,1.6-.521a5.42,5.42,0,0,0,.951-1.463c.028-.047.08-.08.1-.127a1.494,1.494,0,0,0,.142-.578,4.047,4.047,0,0,0-2.954-3.38,6.828,6.828,0,0,0-8.678,4.722A10.372,10.372,0,0,1,6.759,17.1a38.907,38.907,0,0,1-2.9,2.827c-.839.733-1.781,1.345-2.677,2.01A15.162,15.162,0,0,0,15.914,28.7M17.483,4.976c.051.476-.087.961.468,1.122a5.859,5.859,0,0,1,4.5,4.873c.025.15.349.246.534.366.089-.155.265-.322.246-.462a3.415,3.415,0,0,0-.3-.957.959.959,0,0,1,.2-1.209,4.749,4.749,0,0,0,.692-.875c.284-.472.023-.892-.536-.877a1.464,1.464,0,0,0-.548.172c-.762.358-1.355-.053-1.3-.9a3.657,3.657,0,0,0,.006-.745c-.07-.5-.3-.644-.775-.476a5.769,5.769,0,0,0-1.012.468,1,1,0,0,1-1.1,0c-.343-.195-.716-.337-1.076-.5m6.7,9.388A2.394,2.394,0,0,0,22,12.9a.411.411,0,0,0-.244.172c-.163.244-.3.5-.483.8l2.914.5m-5.089,1.01a2.742,2.742,0,0,0-2.181,2.249c1.226-.324,2.23-1.36,2.181-2.249",
    transform: "translate(3.13)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M24.074-30.849h2.48v-1.664h-2.48Z",
    transform: "translate(24.313 18.086)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.092-30.859h2.5v-1.654h-2.5Z",
    transform: "translate(26.569 18.086)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.106-30.862h2.5V-32.51h-2.5Z",
    transform: "translate(28.82 18.09)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.131-30.862h2.5v-1.65h-2.5Z",
    transform: "translate(31.083 18.087)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.145-30.862h2.5V-32.51h-2.5Z",
    transform: "translate(33.334 18.09)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.169-30.871h2.5v-1.648h-2.5Z",
    transform: "translate(35.596 18.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.189-30.871h2.5v-1.648h-2.5Z",
    transform: "translate(37.854 18.08)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(64.123 2.861)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.46 13.795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.74,0,2.057,1.082C1.54,1.645,1.051,2.173.513,2.755L-.662,1.512.74,0",
    transform: "translate(0.662)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1.15.577A1.085,1.085,0,0,1,.068,1.659,1.076,1.076,0,0,1-1.029.6,1.089,1.089,0,0,1,.074-.516,1.1,1.1,0,0,1,1.15.577",
    transform: "translate(1.029 0.516)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondaryHenPack);
export default __webpack_public_path__ + "static/media/secondary-hen-pack.5c9177fbad4d9aaafeeabf4439c48709.svg";
export { ForwardRef as ReactComponent };